/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Spaces_Copying_ItemsInputs */



/**
* | output |
* | --- |
* | "Copying {count} item(s)..." |
*
* @param {Spaces_Copying_ItemsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_copying_items = /** @type {((inputs: Spaces_Copying_ItemsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Copying_ItemsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Element(e) wird/werden kopiert...`)
	return /** @type {LocalizedString} */ (`Copying ${i?.count} item(s)...`)
});